const loginInitValues = {
  userIdAdmin: "",
  pwdAdmin: "",
};

export default loginInitValues;
